var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { useBoolState } from '@/hooks/state/useBoolState';
/**
 * 日程変更モーダルに関するカスタムフック
 */
export const useHotlineScheduleChangeModal = (options) => {
    const { interviewId, onSubmit, requestId, unmountRef } = options;
    // モーダル開閉状態
    const { boolState: isOpenScheduleChangeModal, changeFalse: closeScheduleChangeModal, changeTrue: openScheduleChangeModal, } = useBoolState();
    /**
     * スケジュール日程 送信処理
     */
    const onSubmitScheduleChange = useCallback((formValues) => __awaiter(void 0, void 0, void 0, function* () {
        if (!interviewId) {
            closeScheduleChangeModal();
            return;
        }
        // 送信処理
        yield (onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(requestId, interviewId, formValues));
        if (!unmountRef.current) {
            closeScheduleChangeModal();
        }
    }), [closeScheduleChangeModal, interviewId, onSubmit, requestId, unmountRef]);
    return {
        closeScheduleChangeModal,
        isOpenScheduleChangeModal,
        onSubmitScheduleChange,
        openScheduleChangeModal,
    };
};
